/* eslint-disable @typescript-eslint/no-unused-vars */
import { css, Theme, useTheme, SerializedStyles } from '@emotion/react'
import { FC } from 'react'
import { Field } from 'react-final-form'

import useFormStyles from '~/form/hooks/useFormStyles'

type Props = {
  isShowError?: boolean
  name: string
  htmlFor?: string
  placeholder?: string
}

const InputMultiText: FC<Props> = ({
  name,
  isShowError = false,
  htmlFor,
  placeholder,
}) => {
  const theme = useTheme()

  const { placeholderStyle } = useFormStyles()

  return (
    <div
      css={[
        textAreaStyle(theme, placeholderStyle),
        isShowError && textareaErrorStyle(theme),
      ]}
    >
      <Field
        id={htmlFor}
        name={name}
        component='textarea'
        placeholder={placeholder}
        validate={(value) => {
          if (!value) return
          if (value.length > 4000) {
            return `4000文字以下で入力してください`
          }
        }}
      />
    </div>
  )
}

export default InputMultiText

const textAreaStyle = (theme: Theme, placeholderStyle: SerializedStyles) => css`
  textarea {
    width: 100%;
    min-height: 100px;
    padding: 16px 13px;
    border: 2px solid transparent;
    border-radius: 10px;
    background-color: #fff;
    color: ${theme.color.black};
    font-size: 14px;
    line-height: calc(24 / 14);
    resize: vertical;

    @media (max-width: 767px) {
      padding-block: 11px;
    }

    ${placeholderStyle}

    &:focus {
      transition: box-shadow 400ms cubic-bezier(0.215, 0.61, 0.355, 1);
      box-shadow: 0 0 0 2px ${theme.color.yellow};
    }
  }
`

const textareaErrorStyle = (theme: Theme) => css`
  textarea {
    border-color: ${theme.color.red};
    background: #fbebeb;
  }
`
